import { shadowText } from 'Engine/utils/fontStyles';
import BaseWinContainer from 'Engine/containers/ui/BaseWinContainer';

export default class WinContainer extends BaseWinContainer {
  init() {
    super.init();
    this.titleText.style = {...this.titleText.style, ...shadowText}
  }
}
